'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import type { StoreTimeSchedule } from 'maps/types'

import fukkuStyles from 'fukku/styles/classes.module.scss'
import styles from './Schedule.module.scss'

const NO_DEFINED_SCHEDULE_CHAR = '-'

interface ScheduleProps {
	readonly schedule: StoreTimeSchedule[]
	readonly id: string
}

export function Schedule({ schedule, id }: ScheduleProps) {
	const { t } = useLabels()

	return (
		<table>
			<thead className={fukkuStyles.srOnly}>
				<tr>
					<th>{t('accessibility.storeLocator.card.days.text')}</th>
					<th>{t('accessibility.storeLocator.card.schedule.text')}</th>
				</tr>
			</thead>
			<tbody>
				{schedule.map(({ dayOfWeek, timeList }) => {
					const openHours = timeList.filter(
						({ openHour }) => openHour !== NO_DEFINED_SCHEDULE_CHAR
					)
					if (!openHours.length) {
						return null
					}

					const hours = openHours
						.map(({ openHour, closeHour }) => `${openHour}-${closeHour}`)
						.join(' | ')

					return (
						<tr key={`${id}-${dayOfWeek}`}>
							<th scope='row' className={styles.days}>
								{dayOfWeek}
							</th>
							<td className={styles.hours}>{hours}</td>
						</tr>
					)
				})}
			</tbody>
		</table>
	)
}
